import React from 'react';
import { Panel } from 'react-bootstrap';
import PagedEntitiesList from '../../../common/components/PagedEntitiesList';
import { withTranslation } from 'react-i18next';
import ui from '../../../common/services/ui';

const List = ({ t, ...rest }) => {
	const columns = [
		{
			header: t('RoyaltyReport_Center'),
			accessor: 'center.name',
			sortable: true,
			sortKey: 'center'
		},
		{
			header: t('RoyaltyReport_TotalInclTax'),
			accessor: 'totalInclTax',
			cell: (totalInclTax) => ui.formatAmount(totalInclTax),
			sortable: true
		},
		{
			header: t('RoyaltyReport_LessTax'),
			accessor: 'lessTax',
			cell: (lessTax) => ui.formatAmount(lessTax),
			sortable: true
		},
		{
			header: t('RoyaltyReport_TotalExclTax'),
			accessor: 'totalExclTax',
			cell: (totalExclTax) => ui.formatAmount(totalExclTax),
			sortable: true
		},
		{
			header: t('RoyaltyReport_RoyaltyFee'),
			accessor: 'royaltyFee',
			cell: (royaltyFee) => ui.formatAmount(royaltyFee),
			sortable: true
		},
		{
			header: t('RoyaltyReport_MarketingLevyFee'),
			accessor: 'marketingLevyFee',
			cell: (marketingLevyFee) => ui.formatAmount(marketingLevyFee),
			sortable: true
		},
		{
			header: t('RoyaltyReport_PlusTax'),
			accessor: 'plusTax',
			cell: (plusTax) => ui.formatAmount(plusTax),
			sortable: true
		},
		{
			header: t('RoyaltyReport_AmountPayable'),
			accessor: 'amountPayable',
			cell: (amountPayable) => ui.formatAmount(amountPayable),
			sortable: true
		}
	];

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);